export const promptConstants = {
  REGISTER_REQUEST: 'PROMPT_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'PROMPT_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'PROMPT_REGISTER_FAILURE',

  GET_REQUEST: 'PROMPT_REQUEST',
  GET_SUCCESS: 'PROMPT_SUCCESS',
  GET_FAILURE: 'PROMPT_FAILURE',

  GETALL_REQUEST: 'PROMPT_GETALL_REQUEST',
  GETALL_SUCCESS: 'PROMPT_GETALL_SUCCESS',
  GETALL_FAILURE: 'PROMPT_GETALL_FAILURE',

  DELETE_REQUEST: 'PROMPT_DELETE_REQUEST',
  DELETE_SUCCESS: 'PROMPT_DELETE_SUCCESS',
  DELETE_FAILURE: 'PROMPT_DELETE_FAILURE',
};